import { HOST } from "../constants/HostConstants";
export const userAccept = async (
  user_id,
  email_address,
  update,
  { setUpdate, setPending }
) => {
  try {
    const res = await fetch(`${HOST}/api/user/userAccept`, {
      method: "POST",
      body: JSON.stringify({ user_id, email_address }),
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    const text = await res.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch {
      return { success: false, error: text };
    }
    if (!res.ok) return { success: false, error: data?.error || "Failed" };
    setUpdate(!update);
    setPending(Array.isArray(data) ? data : []);
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.message };
  }
};
